import { styled } from 'styled-components'

export const LineItemTitleContainer = styled.span`
  display: inline-flex;
  align-items: center;
`
